"use client";

import { useAppStore, currentView, isArea } from "@/lib/store";
import { isStaffRole } from "@/components/booking/format";
import { Header } from "@/components/booking/header";
import { Footer } from "@/components/booking/footer";
import { HomeView } from "@/components/booking/home-view";
import { BrowseView } from "@/components/booking/browse-view";
import { ProductDetailView } from "@/components/booking/product-detail-view";
import { MyReservationsView } from "@/components/booking/my-reservations-view";
import { HostDashboardView } from "@/components/booking/host-dashboard-view";
import { AdminDashboardView } from "@/components/booking/admin-dashboard-view";
import { ModeratorView } from "@/components/booking/moderator-view";
import { ExpensesView } from "@/components/booking/expenses-view";
import { DashboardView } from "@/components/booking/dashboard-view";
import { NotificationsView } from "@/components/booking/notifications-view";
import { AuthModal } from "@/components/booking/auth-modal";
import { ProductEditorModal } from "@/components/booking/product-editor-modal";
import { UserEditorModal } from "@/components/booking/user-editor-modal";

export default function Home() {
  const { path, user, authLoading } = useAppStore();
  const view = currentView(path);

  // Guard areas by role; fall back to the Home screen.
  let activeView = view;
  if (!isArea(view) && view !== "home") activeView = view; // product detail passes through
  if (view === "my-reservations" && !user) activeView = "home";
  if (view === "host" && (!user || (user.role !== "OWNER" && user.role !== "ADMIN")))
    activeView = "home";
  if (view === "admin" && (!user || user.role !== "ADMIN")) activeView = "home";
  const isStaff = user && isStaffRole(user.role);
  if (view === "moderator" && !isStaff) activeView = "home";
  if (view === "expenses" && !isStaff) activeView = "home";
  if (view === "dashboard" && !isStaff) activeView = "home";
  if (view === "notifications" && !isStaff) activeView = "home";
  if (view === "product" && !user && authLoading) activeView = "home";

  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">
        {/* Page-level panels render here, in the flow of the container:
            no overlays, no popups, dismissable with their own close control. */}
        <div className="mx-auto w-full max-w-7xl px-4 sm:px-6">
          <div className="grid gap-4 pt-6 empty:hidden">
            <AuthModal />
            <ProductEditorModal />
            <UserEditorModal />
          </div>
        </div>
        {authLoading && activeView !== "product" ? (
          <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6">
            <div className="h-64 w-full animate-pulse rounded-2xl bg-muted" />
          </div>
        ) : activeView === "home" ? (
          <HomeView />
        ) : activeView === "browse" ? (
          <BrowseView />
        ) : activeView === "product" ? (
          <ProductDetailView />
        ) : activeView === "my-reservations" ? (
          <MyReservationsView />
        ) : activeView === "host" ? (
          <HostDashboardView />
        ) : activeView === "admin" ? (
          <AdminDashboardView />
        ) : activeView === "moderator" ? (
          <ModeratorView />
        ) : activeView === "expenses" ? (
          <ExpensesView />
        ) : activeView === "dashboard" ? (
          <DashboardView />
        ) : activeView === "notifications" ? (
          <NotificationsView />
        ) : (
          <HomeView />
        )}
      </main>
      <Footer />
    </div>
  );
}
